import React from "react";
import { Switch, useRouteMatch } from "react-router-dom";
import PrivateRoute from "../../../../Routes/PrivateRoutes";
import FornecedorLeadProvider from "./FornecedorLeadContext";
import PesquisarFornecedorLead from "./Events/PesquisarFornecedorLead";
import FormularioFornecedorLead from "./Events/FormularioFornecedorLead";

const Index = () => {
  let match = useRouteMatch();
  return (
    <FornecedorLeadProvider>
      <div className="container-fluid pl-3 pt-3 pb-3">
        <Switch>
          <PrivateRoute
            exact
            path={`${match.url}`}
            component={PesquisarFornecedorLead}
          />
          <PrivateRoute
            path={`${match.url}/:id`}
            component={FormularioFornecedorLead}
          />
        </Switch>
      </div>
    </FornecedorLeadProvider>
  );
};

export default Index;
